import React, { FC, useEffect, useState } from 'react';
import {
  PageWrapper,
  useShowConfirmationPopup,
  useShowAlertPopup,
  User,
  Lead,
  Customer,
  GenericList,
  Product,
  LoadingAnimation,
  FilterListInput,
  AdditionalLeadListContent,
  ContentBox,
  LeadContent,
  QuestionnaireContent,
} from '@dew21/ui';
import axios from 'axios';
import { useHistory, useParams } from 'react-router';

export const LeadDetails: FC = (props) => {
  const showConfirmationPopup = useShowConfirmationPopup();
  const showNotificationBanner = useShowAlertPopup();

  const { id } = useParams();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<User[] | null>(null);
  const [customers, setCustomers] = useState<Customer[] | null>(null);
  const [products, setProducts] = useState<Product[] | null>(null);
  const [lead, setLead] = useState<Lead | null>(null);

  const fetchUsers = async () => {
    return axios.get('/api/users');
  };

  const fetchProducts = async () => {
    return axios.get('/api/product/all');
  };

  const fetchLead = async () => {
    return axios.get(`/api/leads/${id}`);
  };

  const fetchCustomers = async () => {
    return axios.get('/api/customers');
  };

  useEffect(() => {
    setIsLoading(true);
    fetchUsers()
      .then((response) => setUsers(response.data))
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (users) {
      fetchCustomers()
        .then((response) => setCustomers(response.data))
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [users]);

  useEffect(() => {
    if (customers) {
      fetchProducts()
        .then((response) => setProducts(response.data))
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [customers]);

  useEffect(() => {
    if (products) {
      fetchLead()
        .then((response) => {
          setLead(response.data);
          setIsLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [products]);


  return (
    <PageWrapper
      breadCrumb={[{ title: 'Leads', path: '/leads' }, { title: 'Lead', path: `/leads/${id}` }]}
      marginal={{
        items: [],
      }}>
      <ContentBox>
        {
          lead ?
            <LeadContent
              lead={lead}
              users={users || []}
              customers={customers || []}
              products={products || []} /> :
            'Lead nicht gefunden!'
        }
      </ContentBox>
      <ContentBox>
        {lead && lead.questions.length > 0 ?
          <QuestionnaireContent questions={lead.questions} /> : 'Dieser Lead beinhaltet keine Fragen.'}
      </ContentBox>

      {
        isLoading && <LoadingAnimation transparent overlay />
      }
    </PageWrapper>
  );
};
